export const getOfferParams = transaction => {
  // Must have a valid UUID to consider this a real transaction
  if (!transaction?.id?.uuid) {
    return null;
  }

  // Drill into protectedData and return offerParams if it exists
  return transaction.attributes?.protectedData?.offerParams ?? null;
};

export const getShippingPreference = user => {
  if (!user?.id) return null;

  return user?.attributes?.profile?.publicData?.shippingPreference || null;
};

export const getShippingDetails = user => {
  const address = user?.id && user?.attributes?.profile?.protectedData?.shippingAddress;
  return address || null;
};
export const getShippingDimenisions = user => {
  const shippingDimensions = user?.id && user?.attributes?.profile?.publicData?.shippingDimensions;
  return (
    shippingDimensions || {
      height: '1',
      length: '8.5',
      unit: 'lb',
      weight: '1.2',
      width: '11',
    }
  );
};

export const getUserFullName = user => {
  if (!user?.id) return null;
  const firstName = user?.attributes?.profile?.firstName;
  const lastName = user?.attributes?.profile?.lastName;
  const displayName = user?.attributes?.profile?.displayName;
  return firstName && lastName ? `${firstName} ${lastName}` : displayName;
};

export const getUserEmail = user => user?.attributes?.email || null;

export const getUserPhoneNumber = user =>
  user?.attributes?.profile?.protectedData?.phoneNumber || null;

export const getAddressObjectId = user =>
  user?.id ? user.attributes?.profile?.publicData?.addressObjectId : null;

export const getPayInTotal = tx => (tx?.id ? tx.attributes?.payinTotal?.amount : null);

export const getCarrierParams = tx => (tx?.id ? tx.attributes?.protectedData?.carrierParams : null);

export const getProductWeight = listing => {
  return listing?.attributes?.publicData?.weight ?? 0;
};

export const getMassUnit = listing => (listing?.id ? listing.attributes?.publicData?.unit : null);

export const getPayInTotalCurrency = tx => tx?.attributes?.payinTotal?.currency ?? 'USD';

export const getTrackingInfo = tx => (tx?.id ? tx.attributes?.metadata?.trackingInfo : null);

export const getReturnTrackingInfo = tx =>
  tx?.id ? tx.attributes?.metadata?.returnTrackingInfo : null;

export const getDestinationAddress = tx =>
  tx?.id ? tx.attributes?.metadata?.destinationAddress : null;
